<template>
  <div
    v-if="data && data.value"
    class="checkbox animate__animated animate__bounceIn"
    :class="[
      checked ? 'checkbox-checked' : '',
      isFadeOut && !checked ? 'animate__fadeOut' : ''
    ]"
    :style="classData"
    @click.stop="bindClick"
  >
    <span class="checkbox-num">{{ index | upperChar }}.</span
    ><span v-html="data.value"></span>
    <div class="iconfont icon-gou" v-show="checked && type == 1"></div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    },
    isFadeOut: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 0 //默认单选 1表示多选
    },
    disabled: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    active: {
      default: ''
    },
    sort: {
      type: Number,
      default: 1
    },
    positionData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      checked: false
    }
  },
  computed: {
    classData() {
      let obj = {
        animationDelay: this.isFadeOut
          ? this.active.includes(this.data.key)
            ? '0.5s'
            : '0s'
          : 0.5 + this.index * 0.2 + 's'
      }
      Object.keys(this.positionData).map((key) => {
        obj[key] = this.positionData[key] + 'px'
      })
      return obj
    }
  },
  filters: {
    upperChar(key) {
      return String.fromCharCode(key + 65)
    }
  },
  watch: {
    active() {
      this.updateCheck()
    }
  },
  created() {
    this.updateCheck()
  },
  methods: {
    updateCheck() {
      this.checked =
        (Array.isArray(this.active) && this.active.includes(this.data.key)) ||
        false
    },
    bindClick() {
      if (this.disabled) {
        return
      }
      this.checked = !this.checked
      this.$emit('change', this.index, this.checked)
    }
  }
}
</script>
<style lang="scss" scoped>
.checkbox {
  position: absolute;
  display: inline-block;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.03);
  border-radius: 1000px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  font-size: 15px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #0d0d0d;
  line-height: 22px;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.03);
  padding: 12px 20px;
  box-sizing: border-box;
  white-space: pre-wrap;

  .checkbox-num {
    font-weight: 600;
    margin-right: 4px;
  }

  .iconfont {
    position: absolute;
    right: 0%;
    top: 50%;
    transform: translate(50%, -50%);
    border-radius: 50%;
    overflow: hidden;
    width: 20px;
    height: 20px;
    background: #0e0e0e;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
  }
}

.checkbox-checked {
  background: #81ef5f;
  border: none;
  font-weight: 600;
}
</style>
